import React from "react";
import Slider from "react-slick";
import "./Slider.css"

const NextArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        <div aria-label="Next" className={className + " fas fa-angle-right"} style={style} onClick={onClick} />
    )
};
const PrevArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        <div aria-label="Prev" className={className + " fas fa-angle-left"} style={style} onClick={onClick} />
    )
};

//const ModSlider = (props)  =>{
class ModSlider extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                tablet: window.innerWidth < 992,
                mobile: window.innerWidth < 768,
                autoPlayButton: true
            };
            window.addEventListener("resize", this.resize.bind(this));
        }
        resize(){
            let tablet= window.innerWidth < 992;
            let mobile= window.innerWidth < 520;
            if(mobile !== this.state.mobile || tablet !== this.state.tablet){
                this.setState({mobile:mobile,
                tablet:tablet})
            }
        }

        playPauseButtonClicked = () => {
            this.setState({autoPlayButton: !this.state.autoPlayButton});
        }

        render() {
            const  settings ={
                dots: false,
                infinite: true,
                speed:700,
                slidesToShow: this.state.mobile ? 1 : (this.state.tablet ? 3 : 4),
                slidesToScroll:1,
                centerMode:true,
                autoplay: this.state.autoPlayButton,
                autoplaySpeed: 4000,
                swipeToSlide:true,
                nextArrow: <NextArrow/>,
                prevArrow: <PrevArrow/>,
                adaptiveHeight: false,
                centerPadding: this.state.mobile ? '50px' : 0
            }
            return (
                <React.Fragment>
                    <div className="autoPlayAccessibility" onClick={this.playPauseButtonClicked}>
                        <i className={this.state.autoPlayButton ? "hidePlayButton" : "far fa-play-circle"} alt="הפעל"></i>

                        <i className={this.state.autoPlayButton ? "far fa-pause-circle" : "hidePlayButton"} alt="עצור"></i>
                </div>
                <Slider {...settings}>
                    {this.props.items.map((item,index) => (
                                <div className={index == 1 ? "active item" : "item"} key={"modSliderItem_"+index}>
                                <a href={item.MODMuseumLink_Url}>
                                    <div className="ImgWrap">
                                        <img src={item.ModMuseumImg.ImageUrl} alt={item.Title} className="img-fluid"/>
                                        <h3 className="modSlider-text" dangerouslySetInnerHTML={{__html: item.Title.replace("<br/>", " ")}}></h3>
                                    </div>
                                </a>
                            </div>
                        )) }
                </Slider>
            </React.Fragment>
            );
        }
}

export default ModSlider;

